// extracted by mini-css-extract-plugin
module.exports = {"root":"Eyebrow_root__Me6Vq","text":"Eyebrow_text__6TU_9","stroke":"Eyebrow_stroke__gthZH"};